// extracted by mini-css-extract-plugin
export default {"container":"sidebarHeader_container__StV0k","title":"sidebarHeader_title__DihDo","close":"sidebarHeader_close__cm89I"};